export class TableContextColumn {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "meaning",
            "baseName": "meaning",
            "type": "string",
            "format": ""
        },
        {
            "name": "use",
            "baseName": "use",
            "type": "TableContextColumnUse",
            "format": ""
        },
        {
            "name": "edit",
            "baseName": "edit",
            "type": "TableContextEdit",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextColumn.attributeTypeMap;
    }
    constructor() {
    }
}
